import React, { useEffect, useState } from "react"
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
  Snackbar,
  Alert,
  Modal,
} from "@mui/material"
import { AiOutlineMail } from "react-icons/ai"
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"

import { useNavigate } from "react-router-dom"
import { yupResolver } from "@hookform/resolvers/yup"
import mommylogo from "../../images/login-logo.png"
import baby1 from "../../images/baby1.png"
import baby2 from "../../images/baby3.png"
import baby3 from "../../images/babby3.png"
import baby4 from "../../images/babby4.png"
import googleLogo from "../../images/google-logo.png"
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { useAppSelector } from "../../app/hooks"
import {
  api,
  useLoginMutation,
  useResendVerifyEmailMutation,
  useSignupWithGoogleMutation,
} from "../../features/Auth/authApi"
import CircularProgress from "@mui/material/CircularProgress"
import { toast } from "react-toastify"
import { setResendButton, setString } from "../../features/Auth/WrapperSlice"
import { store, useAppDispatch } from "../../app/store"
import { onBoardKey, token, userDetails } from "../../features/Auth/authSlice"
interface loginUser {
  email: string
  password: string
}
interface loginProps {}

const Login = ({}: loginProps) => {
  const [showPassword, setShowPassword] = React.useState(false)
  const [openSnackbar, setOpenSnackbar] = useState(false)

  const [open, setOpen] = React.useState(false)
  const [EmailVeriFySend, setEmailVerFySend] = useState("")
  const handleOpen = () => setOpen(true)
  const handleResendOtp = () => setOpen(false)
  const dispatch = useAppDispatch()
  const resendButtonVerify = useAppSelector(
    (state) => state?.wrapper?.resendButton,
  )
  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
  }
  const navigate = useNavigate()
  const [userLogin, { isError, error, data, isLoading }] = useLoginMutation()
  const [handleGoogleLogin, {isLoading: googleLoading}] = useSignupWithGoogleMutation()
  const [
    resendVerifyEmail,
    { data: verifyData, error: isverifyError, isLoading: verifyIsloading },
  ] = useResendVerifyEmailMutation()
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  const schemaResolver = yupResolver(
    yup.object().shape({
      email: yup
        .string()
        .required("Please Enter An Email")
        .test("Valid-Email", "Please Enter A Valid Email", (value) =>
          emailRegex.test(value),
        ),
      password: yup.string().required("Please Fill In A Password"),
    }),
  )
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<loginUser>({
    resolver: schemaResolver,
  })

  const onSubmit = (values: any) => {
    dispatch(setString({}))
    setEmailVerFySend(values.email)
    const payload = {
      email: values.email.trim(),
      password: values.password,
    }

    userLogin(payload)
  }

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid pink",
    borderRadius: "8px",

    boxShadow: 24,
    p: 4,
  }
  const viewProfileBtn = {
    display: "inline-block",
    width: "100px",
    padding: "8px 8px",
    border: "1px solid #F475A4",
    borderRadius: "8px",
    color: "#F475A4",
    fontSize: "14px",
    textAlign: "center",
    textDecoration: "none",
    backgroundColor: "#fff",
    "&:hover": {
      color: "#F475A4",
      backgroundColor: "#fff",
    },
  }
  const viewProfileBtnTwo = {
    display: "inline-block",
    width: "100px",
    padding: "8px 8px",
    border: "1px solid #F475A4",
    borderRadius: "8px",
    color: "#fff",
    fontSize: "14px",
    textAlign: "center",
    textDecoration: "none",
    backgroundColor: "#F475A4",
    "&:hover": {
      color: "#F475A4",
      backgroundColor: "#fff",
    },
  }

  useEffect(() => {
    if (error) {
      const errorMessage = (error as any)?.data?.message
      const isEmailVerified = (error as any)?.data?.user?.isEmailVerified
      const isKeyValid = (error as any)?.data

      if (isEmailVerified === false) {
        toast.error(errorMessage, { autoClose: 1000 })
        handleOpen()
      } else if (isKeyValid?.Key == false || isKeyValid?.key == false) {
        dispatch(onBoardKey("onboardingroute" as any))
        dispatch(userDetails({ user: { ...isKeyValid?.userData, signUpWith: "Email" } } as any))
        navigate("/provider-onboarding")
        toast.error(errorMessage, { autoClose: 2000 })
      } else {
        toast.error(errorMessage, { autoClose: 2000 })
        return
      }
    }

    if (data) {
      if (data.Key === false || data.key === false) {
        dispatch(onBoardKey("onboardingroute" as any))
        dispatch(userDetails({ user: { ...data.userData, signUpWith: "Email" } } as any))
        navigate("/provider-onboarding")
        toast.error(data.message || "Please register your account detail to access your account.", {
          autoClose: 2000,
        })
      } else if (data.message) {
        dispatch(token(data?.token))
        navigate("/dashboard")
        toast.success(data?.message, {
          autoClose: 2000,
        })
        dispatch(setResendButton(null as any))
        dispatch(onBoardKey(null as any))
        store.dispatch(api.endpoints.getNotification.initiate({ pageLimit: 3 })),
          setOpenSnackbar(true)
      }
    }
  }, [data, error])

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return
    }
    setOpenSnackbar(false)
  }

  const handleVerifyEmail = () => {
    const payload = {
      email: EmailVeriFySend,
    }
    resendVerifyEmail(payload)
  }

  // verify email toast message display

  useEffect(() => {
    if (verifyData?.message) {
      toast.success(verifyData?.message, { autoClose: 1000 })
      handleResendOtp()
    } else {
      toast.error((isverifyError as any)?.verifyData?.message, {
        autoClose: 1000,
      })
    }
  }, [verifyData])

  return (
    <>
      {(error as any)?.data?.user?.isEmailVerified == false && (
        <Modal
          open={open}
          onClose={handleResendOtp}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          {resendButtonVerify ? (
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Email Verify
              </Typography>
              <Typography id="modal-modal-description" sx={{ my: 2 }}>
                Please Verify The Link Shared On Your Registered Email
              </Typography>
              <Button
                onClick={handleVerifyEmail}
                variant="contained"
                sx={viewProfileBtnTwo}
                className="me-5 "
              >
                {verifyIsloading ? (
                  <Typography fontSize={1}>
                    <CircularProgress
                      style={{ color: "pink", fontSize: 20 }}
                      size={20}
                    />
                  </Typography>
                ) : (
                  "Resend"
                )}
              </Button>{" "}
              <Button
                variant="contained"
                sx={viewProfileBtn}
                className="ms-5 "
                onClick={handleResendOtp}
              >
                Close
              </Button>
            </Box>
          ) : (
            <></>
          )}
        </Modal>
      )}

      <Grid container>
        <Grid
          item
          lg={6}
          className="d-none d-lg-block"
          display="flex"
          alignItems="center"
        >
          <Box className="box-wrapper">
            <Typography
              sx={{
                textAlign: "center",
                color: " #858585",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              Welcome To
            </Typography>
            <Typography textAlign="center">
              <img src={mommylogo} width="300" height="auto" />
            </Typography>
            <Box className="Imgbox" display="flex" flexWrap="wrap" gap={2}>
              <Box>
                <img src={baby1} />
              </Box>
              <Box mt={5}>
                <img src={baby2} />
              </Box>

              <Box>
                <img src={baby3} />
              </Box>

              <Box mt={5}>
                <img src={baby4} />
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item lg={6}>
          <Box>
            <Box className="Loginform">
              <Typography
                variant="h4"
                mt={5}
                fontFamily="Montserrat"
                fontSize={22}
                fontWeight="600"
                color="pink.main"
                textAlign="center"
              >
                Login To Your Account
              </Typography>

              <form onSubmit={handleSubmit(onSubmit)}>
                <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-adornment-password"
                  sx={{
                    color: "white",
                    "&.Mui-focused": {
                      color: "pink.main",
                    },
                  }}
                  >
                    Email
                  </InputLabel>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        {...field}
                        onChange={(e: any) =>
                          field.onChange(e.target.value.trim())
                        }
                        onBlur={(e) => {
                          // Trigger re-validation on blur
                          e.target.value = e.target.value.trim()
                          field.onBlur()
                        }}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault()
                            handleSubmit(onSubmit)()
                          }
                        }}
                        type="email"
                        id="outlined-adornment-password"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <AiOutlineMail />
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Email"
                        sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(55, 50, 50, 0.2)", 
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "pink.main",
                          borderWidth: 2,
                        },
                      }}
                      />
                    )}
                  />
                  <span className="text-danger">{errors?.email?.message}</span>
                </FormControl>
                <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-adornment-password"
                   sx={{
                    color: "white",
                    "&.Mui-focused": {
                      color: "pink.main",
                    },
                  }}
                  >
                    Password
                  </InputLabel>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        {...field}
                        id="outlined-adornment-password"
                        type={showPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                               {showPassword ?  <MdVisibility />:<MdVisibilityOff /> }
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgba(55, 50, 50, 0.2)",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "pink.main",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "pink.main",
                            borderWidth: 2,
                          },
                      }}
                      />
                    )}
                  />
                  <span className="text-danger">
                    {errors?.password?.message}
                  </span>{" "}
                </FormControl>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    onClick={() => navigate("/forget-password")}
                    sx={{
                      color: "#7B7B7B",
                      margin: "8px 0 0 13px",
                      cursor: "pointer",
                    }}
                  >
                    Forgot Password ?
                  </Typography>
                </Box>
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  sx={{ mt: 9, display: "block" }}
                  fullWidth
                >
                  {isLoading ? (
                    <Typography fontSize={1}>
                      <CircularProgress
                        style={{ color: "pink", fontSize: 25 }}
                        size={25}
                      />
                    </Typography>
                  ) : (
                    "Sign in"
                  )}
                </Button>
              </form>
              <Box mb={3} mt={3}>
                <Typography
                  sx={{
                    color: "#7B7B7B",
                    margin: "8px 0 0 13px",
                    textAlign: "center",
                  }}
                >
                  Don’t Have An Account?{" "}
                  <Typography
                    component="span"
                    sx={{ color: "#181818", cursor: "pointer" }}
                    onClick={() => navigate("/signup")}
                  >
                    Sign Up
                  </Typography>
                </Typography>
              </Box>

              <button
                onClick={() => handleGoogleLogin().unwrap().then((r) => window.open(r.url, "_self"))} 
                disabled={googleLoading}
                className="bg-transparent border-0 rounded-circle shadow-lg p-2 mx-auto mt-4">
                <Box>
                  <img src={googleLogo} height={35} />
                </Box>
              </button>
              
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {data?.message}
        </Alert>
      </Snackbar>
    </>
  )
}

export default Login
